import {
    ExamList,
    VerificationCodeSendingStatus,
} from '../../api/ApiClient';
import { createModel } from '@rematch/core';
import apiConnector from '../../api/ApiConnector';

const initialState: IState = {
    requestsList: null,
    smsCodeStatus: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setList(state, requestsList: ExamList) {
            return { ...state, requestsList };
        },
        setSmsCodeStatus(state, smsCodeStatus: VerificationCodeSendingStatus | null) {
            return { ...state, smsCodeStatus };
        },
    },
    effects: (dispatch: any) => ({
        async fetchRequests(payload: FetchExamApplicationsDetails) {
            // dispatch.requests.setList(await apiConnector.execApi(
            //   dispatch,
            //   api => api.getExamInvites(
            //     payload.page,
            //     payload.pageSize,
            //     payload.sortOrder,
            //     payload.sortField,
            //   ),
            // ));
        },
    }),
});

interface IState {
    requestsList: ExamList | null;
    smsCodeStatus: VerificationCodeSendingStatus | null;
}

interface IAcceptInvite {
    examId: string;
    code: string;
    captcha?: string;
}

interface ISendCode {
    examId: string;
    captcha?: string;
}

interface FetchExamApplicationsDetails {
    page: number | undefined;
    pageSize: number | undefined;
    sortOrder: boolean | undefined;
    sortField: string | undefined;
}
